import React from "react";
import Button from "react-bootstrap/Button";

import FloorMapCard from "components/siteRepo/common/floorMapCard";

import "./style.scss";

const ProjectView = ({
  viewSiteData,
  handleDeleteLayer,
  onDuplicateClick,
  handleShowMore,
  showDeleteIcon,
  handleShowMoreProj,
  territoryAccess,
}) => {
  const { projectDetailsList } = viewSiteData;

  return (
    <div className="container-proj">
      {projectDetailsList && projectDetailsList.length
        ? projectDetailsList?.map((project, idx) => {
            return (
              <div className="project-container" key={idx + project.mprojectId}>
                <div className="col-12 d-flex proj-header justify-content-between">
                  <div className="d-flex align-items-center">
                    <span className="item-header">Floor Plan (Project) Name: </span>
                    <span className="item-label">{project.name}</span>
                  </div>
                  <div className="justify-content-end d-flex">
                    <Button variant="primary" onClick={() => handleShowMoreProj({}, "layer", project)}>
                      View/Edit
                    </Button>
                  </div>
                </div>

                <div className="row floors">
                  <div className="d-flex flex-column flex-md-row flex-wrap">
                    {project.layerInfoList.map((layerItem, index) => {
                      return (
                        <FloorMapCard
                          key={index}
                          layerIndex={layerItem.elementIndex}
                          layerObject={layerItem}
                          handleSelection={() => {}}
                          project={project}
                          isSelectable={false}
                          isSiteDetails={showDeleteIcon}
                          projectView={true}
                          removeLayerAction={handleDeleteLayer}
                          isShowMore={true}
                          onShowMoreClick={handleShowMore}
                          onDuplicateClick={onDuplicateClick}
                          territoryAccess={territoryAccess}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })
        : ""}
    </div>
  );
};

export default ProjectView;
